import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import moment from 'moment';
import { Paper, Avatar, Typography, Link, Grid } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CompanyIcon from 'aurora-images/company_profile.svg';
import { isEmpty } from 'lodash';
// import { formatCurrencyWithoutCurrency } from 'aurora-utils/utils';
import stylesNew from './styles';
import { keyEmptyCheck } from '../../utils/utils';

const CurrentMortgage = ({ classes, data }) => {
  const [ownersCollapse, setOwnersCollapse] = useState(true);
  const activeMortgages = data?.mortgages?.filter(item => item?.isActive);

  const { lang } = useSelector(
    createSelector(
      state => state.language,
      language => ({
        lang: language.locale,
      }),
    ),
  );

  return (
    <>
      {!isEmpty(activeMortgages) && (
        <Paper className={(classes.paperCardFrame, classes.main)}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.title}>
              {keyEmptyCheck('current_mortgages', {
                s: activeMortgages?.length,
              })}{' '}
            </Typography>
          </div>

          {!isEmpty(activeMortgages) &&
            activeMortgages?.length > 0 &&
            activeMortgages?.map((mortgage, index) => {
              return (
                <div
                  className={classes.container}
                  style={{
                    display: ownersCollapse && index >= 3 ? 'none' : 'inherit',
                    borderBottom: '1px solid #EBEEF3',
                  }}
                >
                  <Grid container spacing={2} className={classes.accordionDetailsItemContainer}>
                    <Grid textAlign='center' item md={1} xs={12}>
                      <Avatar alt='Avatar alt' src={CompanyIcon} className={classes.large} />
                    </Grid>
                    <Grid item md={11} xs={12} sm container>
                      <Grid container spacing={2}>
                        <Grid item md={3} xs={6}>
                          <Typography className={classes.propertyName}>
                            <FormattedMessage {...messages.bank} />
                          </Typography>
                          <Typography className={classes.propertyValue} component='p' variant='h6'>
                            {lang === 'en' ? mortgage?.bankEn || '-' : mortgage?.bankAr || '-'}
                          </Typography>
                        </Grid>

                        <Grid item md={3} xs={6}>
                          <Typography className={classes.propertyName}>{keyEmptyCheck('mortgage_type')}</Typography>
                          <Typography className={classes.propertyValue} component='p' variant='h6'>
                            {`${lang === 'en' ? mortgage?.mortgageTypeEn : mortgage?.mortgageTypeAr} ${
                              mortgage?.mortgageDegree ? mortgage?.mortgageDegree : ''
                            }`}
                          </Typography>
                        </Grid>
                        {/* {mortgage?.startDate && ( */}
                        <Grid item md={3} xs={6}>
                          <Typography className={classes.propertyName}>
                            <FormattedMessage {...messages.start_date} />
                          </Typography>
                          <Typography className={classes.propertyValue} component='p' variant='h6'>
                            {!isEmpty(mortgage?.startDate) ? moment(mortgage?.startDate).format('DD/MM/YYYY') : '-'}
                          </Typography>
                        </Grid>
                        {/* )} */}
                        {/* {mortgage?.endDate && ( */}
                        <Grid item md={3} xs={6}>
                          <Typography className={classes.propertyName}>
                            <FormattedMessage {...messages.end_date} />
                          </Typography>
                          <Typography className={classes.propertyValue} component='p' variant='h6'>
                            {!isEmpty(mortgage?.endDate) ? moment(mortgage?.endDate).format('DD/MM/YYYY') : '-'}
                          </Typography>
                        </Grid>
                        {/* )} */}

                        <Grid item md={3} xs={6}>
                          <Typography className={classes.propertyName}>
                            <FormattedMessage {...messages.contract_number} />
                          </Typography>
                          <Typography className={classes.propertyValue} component='p' variant='h6'>
                            {mortgage?.contractNumber}
                          </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <Typography className={classes.propertyName}>
                            <FormattedMessage {...messages.mortgage_shares} />
                          </Typography>
                          {mortgage?.mortgageShares?.length === 0 ? (
                            <>
                              {' '}
                              <Typography className={classes.propertyValue} component='p' variant='h6'>
                                <FormattedMessage {...messages.all_shares_100} />
                              </Typography>
                            </>
                          ) : (
                            <>
                              <Typography className={classes.propertyValue} component='p' variant='h6'>
                                {mortgage?.mortgageShares?.length !== 0 && (
                                  <FormattedMessage
                                    {...messages.partial_text}
                                    values={{
                                      num: mortgage?.accumulatedShares,
                                    }}
                                  />
                                )}
                              </Typography>

                              {!isEmpty(mortgage?.mortgageShares) && mortgage?.mortgageShares?.length > 0 ? (
                                mortgage?.mortgageShares.map(owner => {
                                  return (
                                    <>
                                      <Typography className={classes.propertyName}>
                                        {lang === 'en' ? owner?.ownerNameEn : owner?.ownerNameAr}({owner?.share}%)
                                      </Typography>
                                    </>
                                  );
                                })
                              ) : (
                                <Typography className={classes.propertyName}>
                                  <span className={classes.fullShare}> 100%</span>
                                </Typography>
                              )}
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              );
            })}
          {!isEmpty(activeMortgages) && ownersCollapse && activeMortgages?.length - 3 > 0 ? (
            <div className={classes.viewmoreHolder}>
              <Link onClick={() => setOwnersCollapse(!ownersCollapse)}>
                {/* View {propertyDetails?.mortgages.length - 1} more owner  */}
                <FormattedMessage {...messages.view_more} values={{ s: `${activeMortgages?.length - 3}` }} />
                <ExpandMoreIcon />
              </Link>
            </div>
          ) : (
            ''
          )}
          {!isEmpty(activeMortgages) && !ownersCollapse && (
            <div className={classes.viewmoreHolder}>
              <Link onClick={() => setOwnersCollapse(!ownersCollapse)}>
                <FormattedMessage {...messages.view_less_reasons} /> <ExpandLessIcon />
              </Link>
            </div>
          )}
        </Paper>
      )}
    </>
  );
};
CurrentMortgage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  applicationType: PropTypes.object.isRequired,
};

export default withStyles(stylesNew)(CurrentMortgage);
